export default "__VITE_ASSET__BmbOK7gE__"